<template>
  <a-modal
    :visible="hidden"
    :destroyOnClose="true"
    :forceRender="true"
    @cancel="cancel"
    @ok="ok"
    width="520px"
  >
    <template slot="title">
      <span>排序</span><span style="color: #999; font-weight: normal; margin-left: 8px;">通过排序值调整原料排序</span>
    </template>
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" >
      <a-form-item label="原料名称">
        {{rowData.name}}
      </a-form-item>
      <a-form-item label="排序">
        <div style="display: flex; align-items: center; gap: 8px;">
          <a-input-number
            style="flex: 1;"
            placeholder="输入排序值"
            v-decorator="['rawOrder']"
            :max="99999"
            :min="-99999"
          />
          <a @click="quickSubmit(1)" :class="{ disabled: btnLoading }" style="white-space: nowrap;">置顶</a>
          <a @click="quickSubmit(2)" :class="{ disabled: btnLoading }" style="white-space: nowrap;">跟随</a>
        </div>
        <p style="color: #AAAAAA;margin: 0;line-height: 15px;font-size: 12px;">数字越小越靠前</p>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="ok" :loading="btnLoading">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: ['hidden','rowData'],
  data() {
    return {
      form: this.$form.createForm(this),
      btnLoading: false
    }
  },
  watch: {
    hidden(val){
      if(val) {
        let {rawOrder} = this.rowData || {}
        setTimeout(() => {
          this.form.setFieldsValue({rawOrder})
        }, 0);
      }
    },
  },
  methods: {
    ok(){
      this.submitWithOperation(0)
    },
    quickSubmit(type){
      // type: 1=置顶, 2=跟随
      this.submitWithOperation(type)
    },
    submitWithOperation(operationType){
      this.form.validateFields(async (err,values) => {
        if (err && operationType === 0) return;
        let {rawOrder} = values || {}
        this.btnLoading = true
        let {id} = this.rowData || {}

        try {
          const res = await this.$http.post('/nhf-app/factorystaffraw/updateFactoryStaffRawOrder', {
            id,
            rawOrder,
            operationType
          });

          if (res.success) {
            this.$message.success('排序更新成功');
            this.btnLoading = false
            this.$emit('close', true)
          } else {
            this.$message.error(res.msg || '排序更新失败');
            this.btnLoading = false
          }
        } catch (error) {
          this.$message.error('排序更新失败');
          this.btnLoading = false
        }
      })
    },
    cancel(){
      this.$emit('close', false)
    },
  }
}
</script>
